import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Avatar, Grid, Typography } from "@mui/material";
import Btn from "../../Components/Ui_elements/Btn";
import logo from "../../assets/logo/kanhasoft.png";
import { activateAccount } from "../../redux/Thunk/authThunk/login"; // 👈 You must define this thunk
import Loader from "../../Components/Ui_elements/Loader"; // Optional loader if needed
import APP_CONFIG_URL_ENV from "../../env-config";

function ActivateAccount() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [token, setToken] = useState('');

    useEffect(() => {
        const tokenParam = location.pathname.split("/").pop();
        if (tokenParam) setToken(tokenParam);
    }, [location]);

    const handleActivate = () => {
        if (!token) return;
        const payload = {
            activationToken: token
        }

        dispatch(activateAccount(payload))
            .unwrap()
            .then(() => {
                setTimeout(() => navigate("/login"), 2000);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{
                height: "100vh",
                backgroundColor: "#f4f6f8",
                padding: 3,
            }}
        >
            <Grid item xs={12} md={4}
                sx={{
                    backgroundColor: "white",
                    borderRadius: 2,
                    boxShadow: 3,
                    padding: 4,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Avatar
                    src={ `${APP_CONFIG_URL_ENV.REACT_APP_FILEPATH}/images/logo.png`}
                    alt="logo"
                    variant="square"
                    sx={{
                        width: "183px",
                        height: "auto",
                        marginBottom: 3,
                    }}
                />
                <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: 2 }}>
                    Activate Account
                </Typography>
                <>
                    <Typography variant="body2" sx={{ textAlign: "center", marginBottom: 3 }}>
                        Click the button below to activate your account.
                    </Typography>
                    <Btn onClick={handleActivate} >
                        Activate Account
                    </Btn>
                </>
            </Grid>
        </Grid>
    );
}

export default ActivateAccount;
